'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _griddleConnect = require('../utils/griddleConnect');

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _dataSelectors = require('../selectors/dataSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function getSettingsComponentsArrayFromObject(settingsObject, settingsComponents) {
  //TODO: determine if we need to make this faster
  return settingsObject ? Object.keys(settingsObject).sort(function (a, b) {
    var oa = settingsObject[a],
        ob = settingsObject[b];
    return (oa && oa.order || 0) - (ob && ob.order || 0);
  }).map(function (key) {
    return settingsObject[key] && (settingsObject[key].component || settingsComponents && settingsComponents[key]);
  }) : null;
}

var EnhancedSettings = function EnhancedSettings(OriginalComponent) {
  return (0, _compose2.default)((0, _getContext2.default)({
    components: _propTypes2.default.object,
    settingsComponentObjects: _propTypes2.default.object
  }), (0, _griddleConnect.connect)(function (state, props) {
    return {
      className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Settings'),
      style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Settings')
    };
  }), (0, _mapProps2.default)(function (props) {
    var components = props.components,
        settingsComponentObjects = props.settingsComponentObjects,
        otherProps = _objectWithoutProperties(props, ['components', 'settingsComponentObjects']);

    return _extends({
      settingsComponents: getSettingsComponentsArrayFromObject(settingsComponentObjects, components.SettingsComponents)
    }, otherProps);
  }))(function (props) {
    return _react2.default.createElement(OriginalComponent, props);
  });
};

exports.default = EnhancedSettings;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/components/SettingsContainer.js
// module id = 1279
// module chunks = 1